module.exports = __webpack_public_path__ + "assets/img/诚利达.b931252f.png";